/* eslint-disable consistent-return */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-template */
/* eslint-disable import/order */
/* eslint-disable camelcase */
import {
  Button,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Typography,
  makeStyles,
} from '@material-ui/core'
import React, { useEffect, useMemo, useState } from 'react'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import {
  mdiBank,
  mdiCurrencyUsd,
  mdiFilterMultiple,
  mdiMagnify,
  mdiMicrosoftExcel,
} from '@mdi/js'
import Icon from '@mdi/react'
import colors from '../../../assets/colors'
import { useDispatch, useSelector } from 'react-redux'
import CountUp from 'react-countup'
import { getDecimalPart, useQueryParams } from '../../../util/utils'
import { exportBankStatement } from '../BillingActions'
import BaseFilterModal from '../../../components/hooks/BaseFilterModal'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { SNACKBAR } from '../../main/MainActions'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'
import { format, isValid, subDays } from 'date-fns'

const useStyles = makeStyles({
  filterButton: {
    fontSize: '13px',
    lineHeight: '10px',
    color: colors.primary,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  filterButtonIcon: {
    width: '30px',
    height: '30px',
  },
  total: {
    flex: 1,
    color: colors.graylight,
    fontSize: '24px',
    lineHeight: '24px',
  },
  positive: {
    color: colors.sucess,
  },
  negative: {
    color: colors.error,
  },
  cents: {
    fontSize: '16px',
    fontWeight: '400',
  },
})

const BankReportFilter = props => {
  const styles = filterStylesComponents()
  const classes = useStyles()
  const dispatch = useDispatch()

  const banks = useSelector(state => state.billing?.banks)
  const bankBalance = useSelector(state => state.billing?.bankBalance)
  const billingTypes = useSelector(state => state.billing.billingTypes)

  const [open, setOpen] = useState(false)
  const [currentForm, setCurrentForm] = useState({
    date: null,
    date_to: null,
    payment_date_start: filters?.payment_date_start || subDays(new Date(), 30),
    payment_date_end: filters?.payment_date_end || new Date(),
  })

  const location = useLocation()
  const history = useHistory()
  const filters = useQueryParams(location.search)

  const toggleModal = () => {
    setOpen(!open)
  }

  const contUp = money => {
    if (!money) {
      return (
        <CountUp end={0} duration={0.8} prefix="R$" decimal="," separator="." />
      )
    }

    const integerPart = money?.split('.')

    return (
      <CountUp
        end={integerPart[0] || 0}
        duration={0.8}
        prefix="R$"
        decimal=","
        separator="."
      />
    )
  }

  const contUpDecimals = money => {
    if (money === 0) return ',00'
    const decimalPart = getDecimalPart(money)
    return <>{',' + decimalPart}</>
  }

  const onSubmit = (data = filters) => {
    const searchParams = new URLSearchParams(data)
    if (open) toggleModal()
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const handleSubmit = e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)
    data.append(
      'date',
      isValid(currentForm?.date) ? currentForm?.date?.toISOString() : ''
    )
    data.append(
      'date_to',
      isValid(currentForm?.date_to) ? currentForm?.date_to?.toISOString() : ''
    )
    data.append(
      'payment_date_start',
      isValid(currentForm?.payment_date_start)
        ? currentForm?.payment_date_start?.toISOString()
        : ''
    )
    data.append(
      'payment_date_end',
      isValid(currentForm?.payment_date_end)
        ? currentForm?.payment_date_end?.toISOString()
        : ''
    )

    const entries = data.entries()
    const values = Object.fromEntries(entries)

    onSubmit({ ...filters, ...values })
  }

  const handleRelatoryExport = () => {
    if (!filters?.bank_id) {
      return dispatch({
        type: SNACKBAR.INFO,
        success: { message: 'Selecione um banco.' },
      })
    }

    dispatch(exportBankStatement(filters))
  }

  const handleSelectBank = e => {
    e.preventDefault()

    setCurrentForm({
      ...currentForm,
      bank_id: e.target.value,
    })

    onSubmit({ ...filters, bank_id: e.target.value })
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={8}>
        <form style={{ width: '100%' }} onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} className={classes.filterButton}>
              <Icon path={mdiBank} className={classes.filterButtonIcon} />
              <Typography>
                Selecione
                <br />
                um banco:
              </Typography>

              <TextField
                select
                name="bank_id"
                value={filters?.bank_id}
                onChange={handleSelectBank}
                style={{ flex: 1 }}
              >
                <MenuItem value="">Selecione</MenuItem>
                {banks?.map(bank => (
                  <MenuItem value={bank?.id} key={bank?.id}>
                    {bank?.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} className={classes.filterButton}>
              <Icon
                path={mdiCurrencyUsd}
                className={classes.filterButtonIcon}
              />
              <Typography>
                Saldo
                <br />
                atual:
              </Typography>
              <Typography
                className={[
                  classes.total,
                  bankBalance?.balance > 0 ? classes.positive : '',
                  bankBalance?.balance < 0 ? classes.negative : '',
                ]}
              >
                {contUp(bankBalance?.balance || 0)}
                <span className={classes.cents}>
                  {contUpDecimals(bankBalance?.balance || 0)}
                </span>
              </Typography>
            </Grid>
          </Grid>
        </form>
      </Grid>
      <Grid item xs={12} sm={4} container className={styles.areaButtons}>
        <IconButton className={styles.btnMoreFilters} onClick={toggleModal}>
          <Icon path={mdiFilterMultiple} size={1} color={colors.secondary} />
          Outros Filtros
        </IconButton>

        <IconButton className={styles.btnAdd} onClick={handleRelatoryExport}>
          <Icon path={mdiMicrosoftExcel} size={1} />
          Exportar
        </IconButton>
      </Grid>

      <BaseFilterModal open={open} handleOpen={toggleModal} title="FILTRO">
        <Grid
          container
          alignItems="center"
          item
          xs={12}
          justifyContent="flex-start"
          style={{ width: '420px' }}
          spacing={1}
        >
          <Grid item xs={12}>
            <Typography
              style={{ fontSize: '16px', fontWeight: 'normal' }}
              color={colors.primary}
            >
              Utilize os campos para encontrar uma conta
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <form style={{ width: '100%' }} onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item md={6} sm={6} xs={12}>
                  <KeyboardDatePicker
                    clearable
                    value={currentForm.date || filters?.date || null}
                    label="Data do vencimento inicial"
                    fullWidth
                    clearLabel="Limpar"
                    invalidDateMessage="Data inválida"
                    autoOk
                    onChange={date => setCurrentForm({ ...currentForm, date })}
                    format="dd/MM/yyyy"
                  />
                </Grid>

                <Grid item md={6} sm={6} xs={12}>
                  <KeyboardDatePicker
                    clearable
                    value={currentForm.date_to || filters?.date_to || null}
                    label="Data do vencimento final"
                    fullWidth
                    clearLabel="Limpar"
                    invalidDateMessage="Data inválida"
                    autoOk
                    onChange={date_to =>
                      setCurrentForm({ ...currentForm, date_to })
                    }
                    format="dd/MM/yyyy"
                  />
                </Grid>

                <Grid item md={6} sm={6} xs={12}>
                  <KeyboardDatePicker
                    clearable
                    value={
                      currentForm.payment_date_start ||
                      filters?.payment_date_start ||
                      null
                    }
                    label="Data de pagamento inicial"
                    fullWidth
                    clearLabel="Limpar"
                    invalidDateMessage="Data inválida"
                    autoOk
                    onChange={payment_date_start =>
                      setCurrentForm({
                        ...currentForm,
                        payment_date_start,
                      })
                    }
                    format="dd/MM/yyyy"
                  />
                </Grid>

                <Grid item md={6} sm={6} xs={12}>
                  <KeyboardDatePicker
                    clearable
                    value={
                      currentForm.payment_date_end ||
                      filters?.payment_date_end ||
                      null
                    }
                    label="Data de pagamento final"
                    fullWidth
                    clearLabel="Limpar"
                    invalidDateMessage="Data inválida"
                    autoOk
                    onChange={payment_date_end =>
                      setCurrentForm({
                        ...currentForm,
                        payment_date_end,
                      })
                    }
                    format="dd/MM/yyyy"
                  />
                </Grid>

                <Grid item sm={12}>
                  <TextField
                    select
                    name="bill_type_id"
                    label="Tipo de Conta"
                    fullWidth
                    defaultValue={filters?.bill_type_id}
                  >
                    <MenuItem key="" value="">
                      Selecione...
                    </MenuItem>
                    {billingTypes?.map(billingType => (
                      <MenuItem key={billingType.id} value={billingType.id}>
                        {billingType.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid
                  item
                  xs
                  container
                  justifyContent="center"
                  alignITems="center"
                >
                  <Button className={styles.btnSalvar} type="submit">
                    <Icon path={mdiMagnify} size={1} />
                    {` Filtrar`}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </BaseFilterModal>
    </Grid>
  )
}

export default BankReportFilter
